import { render } from "./deviation-list.vue?vue&type=template&id=6b827400"
import script from "./deviation-list.vue?vue&type=script&lang=js"
export * from "./deviation-list.vue?vue&type=script&lang=js"

import "./deviation-list.vue?vue&type=style&index=0&id=6b827400&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__